import { withDocumentStyles } from "../../lib/document-route";
import { creatorPageHead, shellFrom } from "../../lib/head";
import type { LoadedMatchupGuide } from "../../server/matchups";

// Route heads stay in the site's first bundle, so this module imports no components: the guide's
// own code loads only with a guide.

/** A guide's title, description and address, with its template's styles when it has one. */
export function guideHead(
  matches: readonly { loaderData?: unknown; routeId: string }[],
  guide: LoadedMatchupGuide | undefined,
) {
  const shell = shellFrom(matches);
  if (!shell || !guide) return {};
  return withDocumentStyles(
    creatorPageHead(shell, {
      pathname: guide.canonicalPath,
      title: guide.title,
      description: guide.description,
      article: true,
    }),
    guide.template?.document,
  );
}
